import React from 'react'
import classNames from 'classnames'

import { MessageProps } from '../containers/ConnectedMessage'

const Message: React.FC<MessageProps> = props => {
	if (props.message.type === null) {
		return null
	}

	return (
		<div className={classNames('message', `message--${props.message.type}`)}>
			{props.message.text}
		</div>
	)
}

export default Message
